import { makeStyles } from '@material-ui/styles'

let profilePicDiameter = '120px'
export const useStyles = makeStyles(({ typographyPresets, colors }) => ({
    profilePicContainer: {
        display: 'none', //TODO change to flex when this option is enabled
        marginTop: '20px',
    },
    profilePicPanel: {
        marginLeft: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    profilePic: {
        display: 'flex',
        height: profilePicDiameter,
        width: profilePicDiameter,
        borderRadius: `calc(${profilePicDiameter} / 2)`,
        backgroundColor: colors.light.grey,
    },
    editButton: {
        width: '121px !important',
    },
    editMessage: {
        marginTop: '9px',
        ...typographyPresets.labelPrimary,
        color: colors.light.darkgrey,
    },
    submit: {
        display: 'flex',
    },
    message: {
        ...typographyPresets.labelPrimary,
        display: 'flex',
        alignItems: 'center',
        margin: '0 10px',
    },
    error: {
        color: 'red',
    },
    success: {
        color: '#43c17d',
    },
}))
